import React from 'react'
import './Aboutus.css'

function Aboutus() {
    return (
        <div className='introduction'>
            <h2>About us:</h2>
            <img class="intro" src='/images/belur.jpeg' alt="about-us"/>
        </div>
    )
}

export default Aboutus
